import { useState, useEffect } from "react";
import { client } from "@/utils/sanity";

export const useAboutInfoData = () => {
  const [aboutInfo, setAboutInfo] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const query = `*[_type == "aboutInfo"][0]`;
        const data = await client.fetch(query);
        setAboutInfo(data);
      } catch (error) {
        console.error("Error fetching about info data:", error);
      }
    };

    fetchData();
  }, []);

  return aboutInfo;
};
